<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      :router="false"
      v-if="menus.length > 0"
    >
      <template v-for="(item, item_index) in menus">
        <template v-if="item.sub_menu.length > 0">
          <el-submenu :index="item.path_name" :key="item_index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="(subItem, subItem_index) in item.sub_menu">
              <el-submenu
                v-if="subItem.type != 2 && subItem.sub_menu.length > 0"
                :index="subItem.path_name"
                :key="subItem_index"
              >
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.sub_menu"
                  :key="i"
                  :index="threeItem.path_name"
                  @click="toLink(threeItem)"
                  >{{ threeItem.title }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                v-else
                :index="subItem.path_name"
                :key="subItem_index"
                @click="toLink(subItem)"
                >{{ subItem.title }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item
            :index="item.path_name"
            :key="item_index"
            @click="toLink(item)"
          >
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>

    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router
      v-else
    >
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu
                v-if="subItem.subs"
                :index="subItem.index"
                :key="subItem.index"
              >
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                  >{{ threeItem.title }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index"
                >{{ subItem.title }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from "../common/bus";
import http from "../../api/manageApiConfig";

export default {
  data() {
    return {
      collapse: false,
      items: [
        {
          icon: "el-icon-info",
          index: "labelmanage",
          title: "标签管理",
          subs: [
            {
              index: "classificationManage",
              title: "类别管理",
            },
            {
              index: "labelManage",
              title: "标签管理",
            },
          ],
        },
        {
          icon: "el-icon-s-management",
          index: "bookCategoriesManage",
          title: "古籍分类管理",
          subs: [
            {
              index: "zkCategories",
              title: "基础古籍分类",
            },
            {
              index: "ywCategories",
              title: "域外古籍分类",
            },
            {
              index: "wqCategories",
              title: "孤本古籍分类",
            },
          ],
        },
        {
          icon: "el-icon-s-management",
          index: "bookManage",
          title: "古籍管理",
          subs: [
            {
              index: "zkBooks",
              title: "基础古籍管理",
            },
            {
              index: "ywBooks",
              title: "域外古籍管理",
            },
            {
              index: "wqBooks",
              title: "孤本古籍管理",
            },
            {
              index: "dynastiesManage",
              title: "朝代管理",
            },
            {
              index: "bookListManage",
              title: "书单管理",
            },
          ],
        },
        {
          icon: "el-icon-document-copy",
          index: "knowledgeBase",
          title: "知识库管理",
          subs: [
            {
              index: "yianManage",
              title: "医案管理",
            },
            {
              index: "fangjiManage",
              title: "方剂管理",
            },
            {
              index: "bencaoManage",
              title: "本草管理",
            },
            {
              index: "jingxueManage",
              title: "经穴管理",
            },
            {
              index: "mingyiManage",
              title: "名医管理",
            },
            {
              index: "zhenyanManage",
              title: "珍言管理",
            },
            {
              index: "zhenyanDayManage",
              title: "珍言推送列表",
            },
          ],
        },
        {
          icon: "el-icon-chat-dot-round",
          index: "chineseMedicine",
          title: "中医圈管理",
          subs: [
            {
              index: "QAMedicine",
              title: "问答管理",
            },
            {
              index: "publicNoteManage",
              title: "公开笔记管理",
            },
          ],
        },
        {
          icon: "el-icon-lx-service",
          index: "operationmanage",
          title: "互动管理",
          subs: [
            {
              index: "commentList",
              title: "评论管理",
            },
            // {
            //   index: "replyList",
            //   title: "回复管理",
            // },
          ],
        },
        {
          icon: "el-icon-lx-service",
          index: "institution",
          title: "校园网管理",
          subs: [
            {
              index: "institutionManage",
              title: "校园网管理",
            },
          ],
        },
      ],
      menus: [],
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
  created() {
    if (this.getQueryString("t")) {
      this.getData();
    }
    bus.$on("collapse", (msg) => {
      this.collapse = msg;
      bus.$emit("collapse-content", msg);
    });
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getData() {
      let that = this;
      let params = {
        role_id: localStorage.getItem("ms_role"),
      };
      http.get("/admin/menus", { params: params }).then(function(res) {
        that.menus = res.data;
      });
    },
    toLink(item) {
      window.location.href =
        item.url + "?t=1" + `&token=` + localStorage.getItem("ms_token");
    },
  },
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}

.sidebar > ul {
  height: 100%;
}
</style>
